import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { ValueSection } from './components/ValueSection';
import { AuthorSection } from './components/AuthorSection';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';

// Declare fbq on window for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
    _pixelInitialized?: boolean;
    _scrollMilestonesReached?: Set<number>;
  }
}

// Initialize Pixel outside component to guarantee single execution
if (typeof window !== 'undefined' && !window._pixelInitialized) {
  window._pixelInitialized = true;
  if (!window.fbq) {
    const n: any = function (...args: unknown[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    window.fbq = n;
    window._fbq = n;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    (document.head || document.documentElement).appendChild(script);
  }
  window.fbq('init', '855275007473565');
  window.fbq('track', 'PageView');
  window.fbq('track', 'ViewContent');

  // Setup Scroll Tracking globally
  window._scrollMilestonesReached = new Set<number>();
  const milestones = [25, 50, 75, 90, 100];
  const handleScroll = () => {
    if (!window.fbq || !window._scrollMilestonesReached) return;
    const scrollPosition = window.scrollY + window.innerHeight;
    const totalHeight = document.documentElement.scrollHeight;
    if (totalHeight === 0) return;
    const scrollPercentage = scrollPosition / totalHeight * 100;
    milestones.forEach(milestone => {
      if (scrollPercentage >= milestone && !window._scrollMilestonesReached!.has(milestone)) {
        window._scrollMilestonesReached!.add(milestone);
        window.fbq('trackCustom', 'ScrollDepth', {
          percentage: milestone,
          page: 'Landing Page Merezco la Vida'
        });
      }
    });
  };
  window.addEventListener('scroll', handleScroll, {
    passive: true
  });
  // Initial check in case they load halfway down the page
  setTimeout(handleScroll, 1000);
}
export function App() {
  return <div className="min-h-screen bg-primary text-gray-100 font-body selection:bg-violet/30 selection:text-white" data-id="element-0" data-mp="3limqsg4951eu">
      <UrgencyBar data-id="element-1" data-mp="2sw207hvlotcc" />
      <Hero data-id="element-2" data-mp="2swlix0t2rlrf" />
      <TrustBar data-id="element-3" data-mp="2suqv9eqf5fjn" />
      <PainSection data-id="element-4" data-mp="2svadyxnw87yq" />
      <SolutionSection data-id="element-5" data-mp="2stzdp7tnpicd" />
      <BonusesSection data-id="element-6" data-mp="18e19rkmjbok1" />
      <ValueSection data-id="element-7" data-mp="18cq7jp8qmov1" />
      <AuthorSection data-id="element-8" data-mp="18c6pm8j380h0" />
      <Testimonials data-id="element-9" data-mp="18bolyqu3ijz2" />
      <Guarantee data-id="element-10" data-mp="1d47wfexhkyzn" />
      <FAQ data-id="element-11" data-mp="1d4rfiyyvhtf9" />
      <FinalCTA data-id="element-12" data-mp="1d5j9y6gqhl3y" />
      <Footer data-id="element-13" data-mp="1d62gys4uip37" />
      <FloatingCTA data-id="element-14" data-mp="1d6knchl82jou" />
    </div>;
}